import React, {useEffect, useRef, useState} from "react";
import "./HomePage.scss";
import IntroSection from "../../components/HomePageComp/IntroSection/IntroSection";
import BrokerSection from "../../components/HomePageComp/BrokerSection/BrokerSection";
import FundingSection from "../../components/HomePageComp/FundingSection/FundingSection";
import PhaseSection from "../../components/HomePageComp/PhaseSection/PhaseSection";
import DashboardSection from "../../components/HomePageComp/DashboardSection/DashboardSection";

import AlphaGroupSection from "../../components/HomePageComp/AlphaGroupSection/AlphaGroupSection";
import TestimonialSection from "../../components/HomePageComp/TestimonialSection/TestimonialSection";
import MarketSummarySection from "../../components/HomePageComp/MarketSummarySection/MarketSummarySection";
import VisionBlogSection from "../../components/HomePageComp/VisionBlogSection/VisionBlogSection";
import Test from "../../components/HomePageComp/CheckoutSection/TestCheckout";
import TestCheckout from "../../components/HomePageComp/CheckoutSection/TestCheckout";
import CheckoutSection from "../../components/HomePageComp/CheckoutSection/CheckoutSection";
import axios from "axios";
import TradersInterviewSection from "../../components/HomePageComp/TradersInterviewSection/TradersInterviewSection";

import {useSelector} from "react-redux";

const HomePage = () => {
  const {isLoading, challenges} = useSelector((state) => state.challengesData) || {};

  const [selectedPlanId, setSelectedPlanId] = useState(null);

  const checkoutPageRef = useRef(null);

  // useEffect(() => {
  //   const fetchChallenges = async () => {
  //     try {
  //       const response = await axios.get("https://backend.alphacapitalgroup.uk/v2/challenges/");
  //       const {data} = response;
  //       setChallenges(data);
  //     } catch (err) {
  //       console.error("Error fetching challenges:", err);
  //     }
  //   };

  //   fetchChallenges();
  // }, []);

  console.log("challenges", challenges);

  const scrollToSection = (ref) => {
    ref?.current?.scrollIntoView({
      behavior: "smooth",
      block: "start",
    });
  };

  const handleScrollToCheckout = (id) => {
    console.log("id", id);
    setSelectedPlanId(id);
    scrollToSection(checkoutPageRef);
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="homePageContainer">
      <div className="homePageWrapper">
        <IntroSection />
        <BrokerSection />
        <div id="TestYourSkills">
          <FundingSection
            selectedPlanId={selectedPlanId}
            handleScrollToCheckout={handleScrollToCheckout}
            apiData={challenges}
            isLoading={isLoading}
          />
        </div>
        <div ref={checkoutPageRef}>
          <CheckoutSection
            challenges={challenges || {}}
            selectedPlanId={selectedPlanId}
          />
        </div>
        <TradersInterviewSection />
        <div id="evaluations">
          <PhaseSection />
        </div>
        <DashboardSection />
        <AlphaGroupSection />
        <TestimonialSection />
        <VisionBlogSection />
        <MarketSummarySection />
      </div>
    </div>
  );
};

export default HomePage;
